<template>
  <div class="asc-derivedParameters--noData mx-6">
    <asc-accent-button
      button-text="Create Custom Parameter"
      :on-click="handleAddDerivedParameter"
      :outline="true"
      :secondary="true"
      :block="true"
    ></asc-accent-button>
    <p>
      You currently have no custom parameters.<br />Click Create Custom
      Parameter to quickly create your own custom parameters.
    </p>
  </div>
</template>

<script>
import AscAccentButton from './AscAccentButton'

export default {
  name: 'AscDerivedParametersNoData',

  components: {
    AscAccentButton,
  },

  methods: {
    handleAddDerivedParameter() {
      this.$emit('openAlertTypeDialog')
    },
  },
}
</script>

<style lang="scss">
.asc-derivedParameters--noData {
  background: $primary-white;
  display: flex;
  flex-direction: column;

  p {
    margin: 10% auto 0 auto;
    text-align: center;
    font-size: 14px;
  }
}
</style>
